

































































import MyFooter from 'components/my-footer.vue'
import Loading from 'components/loading.vue'
import Mixin from 'common/mixin'
import { mapState } from "vuex";
import Vue from "vue"

export default Vue.extend({
    name: 'LoginLayout',
    mixins: [Mixin],
    props: {
        title: String,
        footerEnabled: Boolean
    },
    data: function () {
        return {
        }
    },
    computed: {
        ...mapState(['loading']),
    },
    mounted() {
    },
    methods: {
    },
    components: {
        MyFooter,
        Loading
    }
})
